import React from "react";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { weekLabel, weeksInYear } from "@/lib/semanas";

const YEARS = Array.from({ length: new Date().getFullYear() - 2022 }, (_, i) => 2024 + i);

export function WeekPicker({ year, week, setYW }) {
  const max = weeksInYear(year);
  const step = (d) => {
    let y = year, w = week + d;
    if (w < 1) { y -= 1; w = weeksInYear(y); } else if (w > max) { y += 1; w = 1; }
    setYW({ year: y, week: w });
  };
  return (
    <div className="flex flex-wrap items-center gap-2 min-w-0 max-w-full" data-testid="flete-week-picker">
      <CalendarDays className="w-4 h-4 text-slate-400" />
      <Select value={String(year)} onValueChange={(v) => setYW({ year: Number(v), week: Math.min(week, weeksInYear(Number(v))) })}>
        <SelectTrigger className="h-9 w-24 bg-slate-50 border-slate-200 text-sm" data-testid="flete-year"><SelectValue /></SelectTrigger>
        <SelectContent>{YEARS.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent>
      </Select>
      <button onClick={() => step(-1)} data-testid="flete-week-prev" className="h-9 w-9 rounded-lg border border-slate-200 flex items-center justify-center hover:bg-slate-50"><ChevronLeft className="w-4 h-4" /></button>
      <Select value={String(week)} onValueChange={(v) => setYW({ year, week: Number(v) })}>
        <SelectTrigger className="h-9 flex-1 min-w-[12rem] sm:flex-none sm:w-72 bg-slate-50 border-slate-200 text-sm" data-testid="flete-week"><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-72">{Array.from({ length: max }, (_, i) => i + 1).map((w) => <SelectItem key={w} value={String(w)}>{weekLabel(year, w)}</SelectItem>)}</SelectContent>
      </Select>
      <button onClick={() => step(1)} data-testid="flete-week-next" className="h-9 w-9 rounded-lg border border-slate-200 flex items-center justify-center hover:bg-slate-50"><ChevronRight className="w-4 h-4" /></button>
    </div>
  );
}
